module.exports = __webpack_public_path__ + "assets/00a6a3ddf1e918c404ca0ea00023687b.jpg";